module.exports = __webpack_public_path__ + "static/img/empty.ed693808.png";